export const APILIST = [
  {
    id: "JOB_POST_PROCESS",
    title: "Job Posting Process",
    api: "job-posting-feedback",
    postKey: {
      feedback: "job_post_feedback",
      comment: "job_post_comment"
    }
  },
  {
    id: "CANDIDATE_QUALITY",
    title: "Candidate Quality",
    api: "candidate-quality-feedback",
    postKey: {
      feedback: "candidate_quality_feedback",
      option: "candidate_quality_option",
      comment: "candidate_quality_comment"
    }
  },
  {
    id: "COMMUNICATION_AND_SUPPORT",
    title: "Communication & Support",
    api: "communication-support-feedback",
    postKey: {
      feedback: "communication_support_feedback",
      comment: "communcation_support_comment",
      response_time_feedback: "response_time_feedback",
      response_time_comment: "response_time_comment"
    }
  },
  {
    id: "FEATURE_SERVICES",
    title: "Features or Services",
    api: "feature-service-feedback",
    postKey: {
      comment: "feature_service_comment"
    }
  },
  {
    id: "OTHER",
    title: "Other",
    api: "other-reason-feedback",
    postKey: {
      comment: "recruiter_other_comment"
    }
  }
];

export const SUCCESS_MSG = {
  JOB_POST_PROCESS: {
    title: "We are glad you found it easy!",
    icon: "birthday.svg"
  },
  CANDIDATE_QUALITY: {
    title: "Congratulations!",
    icon: "star.svg"
  },
  COMMUNICATION_AND_SUPPORT: {
    title: "Congratulations!",
    icon: "star.svg"
  }
};
export const WARNING_MESSAGE =
  "Please don’t share sensitive info like bank details.";
export const HELP_CONTACT = `1800-203-5244`;
